<template>
    <v-card elevation="1" class="rounded-lg mb-4 white">
        <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
            <span class="primary--text font-weight-medium">Progetto:</span>
            <span class="ml-2">{{ project.name }}</span>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="4">
                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Ore progetto:</span>
                        <v-chip color="primary" small outlined class="font-weight-medium">{{ project.total_hours }} ore</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Insegna:</span>
                        <span>{{ project.customer_name }}</span>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Stato:</span>
                        <v-chip small :color="getStatusColor(project.status)" outlined class="font-weight-medium">{{ project.status_display }}</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>
                </v-col>
                <v-col cols="4">
                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Inizio Promozione:</span>
                        <v-chip color="primary" small outlined class="font-weight-medium">{{ formatDate(detail_project.data_promozione_dal) }}</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Fine Promozione:</span>
                        <v-chip color="primary" small outlined class="font-weight-medium">{{ formatDate(detail_project.data_promozione_al) }}</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Inizio Sottocosto:</span>
                        <v-chip color="success" small outlined class="font-weight-medium">{{ formatDate(detail_project.data_sottocosto_dal) }}</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Fine Sottocosto:</span>
                        <v-chip color="success" small outlined class="font-weight-medium">{{ formatDate(detail_project.data_sottocosto_al) }}</v-chip>
                    </div>
                </v-col>
                <v-col cols="4">
                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Referente:</span>
                        <span>{{ project.owner_fullname }}</span>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Codice:</span>
                        <v-chip color="info" small outlined class="font-weight-medium">{{ project.custom_id }}</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>

                    <div class="d-flex justify-space-between align-center mb-2">
                        <span class="font-weight-medium primary--text">Data creazione:</span>
                        <v-chip color="info" small outlined class="font-weight-medium">{{ formatDate(project.created_at) }}</v-chip>
                    </div>
                    <v-divider class="mb-2"></v-divider>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import {format, parseISO} from "date-fns";
import projectService from "../../services/project.service";

export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data() {
      return {
        project_id: this.project.id,
        detail_project: []
      }
    },
    mounted() {
      this.initProject()
    },
  methods: {
        initProject() {
          projectService.get(this.project_id)
            .then(resp => {
              this.detail_project = resp.data
            })
        },
        formatDate(isoDate) {
            return isoDate ? format(parseISO(isoDate), 'dd/MM/yyyy') : '-';
        },
        getStatusColor(status) {
            switch(status) {
                case 'OPEN': return 'success';
                case 'CLOSED': return 'error';
                case 'PENDING': return 'warning';
                default: return 'primary';
            }
        }
    }
}
</script>
